import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
const SuccessIcon = (props: SvgProps) => (
  <Svg
    width={52}
    height={50}
    fill='none'
    {...props}
  >
    <Path
      fill='#C0A46F'
      d='m18.23 49.164-4.375-7.384-8.348-1.782.83-8.577L.747 25l5.59-6.422-.83-8.574 8.355-1.78 4.363-7.39 7.772 3.323L33.769.836l4.373 7.385 8.35 1.781-.832 8.577L51.25 25l-5.59 6.421.831 8.574-8.355 1.78-4.363 7.39-7.772-3.323-7.772 3.322Zm1.051-3.17 6.718-2.789 6.749 2.79 3.836-6.318 7.248-1.64-.671-7.474 4.9-5.563-4.9-5.594.671-7.474-7.248-1.609-3.867-6.318-6.718 2.79-6.749-2.79-3.836 6.318-7.248 1.608.67 7.475L3.938 25l4.9 5.563-.671 7.506 7.248 1.608 3.867 6.318Zm3.959-13.578L36.214 19.44l-1.764-1.754-11.201 11.21-5.701-5.702-1.764 1.764 7.456 7.457Z'
    />
  </Svg>
);
export default SuccessIcon;
